<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Sword of the Lamb</h1>
</div>
</div>
<h3>
	Book One of <em>The Phoenix Legacy</em></h3>
<p>
</p>
<h2 style="text-align: center;">
<strong>M.​K. Wren</strong></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003title.vue?59521aae